import { useMutation, useQuery } from "@apollo/react-hooks";
import { ChoiceList, Modal } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { CREATE_OR_UPDATE_INVOICE_FOR_SELLER } from "../../../graphql/mutations";
import { useToastContext } from "../../shared/ToastContext";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import { GET_USERS } from "../../../graphql/queries";
import { get } from "lodash";
import useTimeout from "../../../hooks/useTimeout";

export default function CreateInvoiceForSeller({ open, onClose, refetch }) {
    const [state, setState] = useReducer(reducerFn, {
        userIDs: [],
    });

    const { toggleToast, setNotify } = useToastContext();

    const { data } = useQuery(GET_USERS, {
        variables: {
            filter: {
                isEnabledInvoice: true,
            },
        },
    });

    const [setDelay] = useTimeout();
    const [createInvoice, { loading }] = useMutation(
        CREATE_OR_UPDATE_INVOICE_FOR_SELLER,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Create Invoice for Seller success",
                    err: false,
                });

                onClose && onClose();
                setDelay(() => {
                    refetch && refetch();
                }, 1500);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(state.userIDs)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        createInvoice({
            variables: {
                input: {
                    userIDs: state.userIDs,
                },
            },
        });
    }, [toggleToast, setNotify, createInvoice, state.userIDs]);

    const handleSellerChange = useCallback((selected) => {
        setState({ userIDs: selected });
    }, []);

    return (
        <Modal
            title="Create Invoice for Seller"
            sectioned
            open={open}
            onClose={onClose}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <ChoiceList
                choices={getUsers(data) || []}
                allowMultiple
                selected={state.userIDs}
                onChange={handleSellerChange}
                title="Sellers"
            />
        </Modal>
    );
}

function getUsers(data) {
    const users = get(data, "users.nodes") || [];

    const res = [];
    for (let user of users) {
        if (!user || !user.id) continue;

        let name = [user.firstName, user.lastName].filter(Boolean).join(" ");

        if (user.email) {
            name += ` (${user.email})`;
        }

        res.push({ value: user.id, label: name });
    }

    return res;
}
